import React, { useState, useEffect } from "react";
import styles from "./CustomerPanel.module.css";
import API from "../../services/api";
import SlotSelectionModal from "./SlotSelectModal1";
import {Alert, Button, Card, FormControl, InputGroup, ListGroup, Modal, Spinner, Table} from "react-bootstrap";
import {Minus, Plus, Trash2} from "lucide-react";
import CheckoutModal from "./CheckoutModal";

const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:8000";

const spiceLevels = ["1 Mild", "2 Medium", "3 Hot", "4 Very Hot", "5 Extra Hot"];
const SPICE_LEVELS = [
    { value: "mild",       title: "1 マイルド",     en_title: "1 MILD",       index: 1, icon: "" },
    { value: "medium",     title: "2 普通",          en_title: "2 MEDIUM",     index: 2, icon: "🌶🌶" },
    { value: "hot",        title: "3 中辛",          en_title: "3 HOT",        index: 3, icon: "🌶🌶🌶"},
    { value: "very_hot",   title: "4 大辛",          en_title: "4 VERY HOT",   index: 4, icon: "🌶🌶🌶🌶"},
    { value: "super_hot",  title: "5 激辛",          en_title: "5 SUPER HOT",  index: 5, icon: "🌶🌶🌶🌶🌶" }
];

const CustomerPanel = () => {
    const [orders, setOrders] = useState([]);
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [selectedCat, setSelectedCat] = useState(null);
    const [selectedSpice, setSelectedSpice] = useState(spiceLevels[0]);
    const [selectedQty, setSelectedQty] = useState(1);
    const [menu, setMenu] = useState({});
    const [showSlotModal, setShowSlotModal] = useState(false);  // show/hide slot modal
    const [activeSlot, setActiveSlot] = useState(null);         // currently clicked slot
    const [selectedSlotFoods, setSelectedSlotFoods] = useState([]); // foods selected in slot
    const [ln, setLn] = useState("jp");
    const [cart, setCart] = useState([]);
    const [showCheckout, setShowCheckout] = useState(false);
    const [user, setUser] = useState(null);
    const [showOrdersModal, setShowOrdersModal] = useState(false);
    const [loadingOrders, setLoadingOrders] = useState(false);
    const [ordersError, setOrdersError] = useState(null);

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        let lnParam = params.get("ln") || "";
        if (lnParam !== 'en') { lnParam = 'jp'}
        setLn(lnParam);
    }, []); // empty dependency array → runs only once on mount

    // Fetch orders when modal opens
    useEffect(() => {
        if (!showOrdersModal) return;

        const fetchOrders = async () => {
            try {
                setLoadingOrders(true);
                setOrdersError(null);

                // Use centralized API service
                const res = await API.get("/user-orders");
                setOrders(res.data.data || []);
            } catch (err) {
                setOrdersError(err.response?.data?.message || "Failed to load orders.");
            } finally {
                setLoadingOrders(false);
            }
        };

        fetchOrders();
    }, [showOrdersModal]);

    const MENU_LAVEL = [
        { label: "A-la-carte menu", jp: "単品メニュー", value: "thampin", time: "10:00 ~ 15:00" },
        { label: "Lunch Menu", jp: "ランチメニュー", value: "lunch", time: "10:00 ~ 15:00" },
        { label: "Dinner Menu", jp: "夕食", value: "dinner", time: "15:00 ~ 20:00" },
    ];

    function getMenuRow(value) {
        return MENU_LAVEL.find(item => item.value === value) || null;
    }

    function getSpiceTitle(value) {
        const item = SPICE_LEVELS.find(level => level.value === value);
        return item ? (ln === 'en' ? item.en_title : item.title) : '';
    }

    const imageSrc = (src)=> {
        return BASE_URL + "/storage/" + src;
    }

    const fetchCart = async () => {
        try {
            const cartRes = await API.get("/cart");

            setCart(
                (cartRes.data.data || []).map((c) => ({
                    id: c.id,
                    type: c.type || (c.food ? "food" : "set_menu"),
                    title: c.food?.name || c.set_menu?.title || "",
                    jp: c.food?.japanese_name || c.set_menu?.japanese_title || "",
                    price: c.price || c.food?.price || c.set_menu?.cost || 0,
                    quantity: c.quantity,
                    image: c.food?.image || c.set_menu?.images?.[0] || '',
                    slots: c.slots || [],
                    spice_level: c.spice_level || "",
                    total_price: c.total_price || 0,
                }))
            );
        } catch (err) {
            console.error("Failed to fetch cart", err);
        }
    };

// --- Fetch Data ---
    const fetchMenuData = async () => {
        try {
            // First, fetch user
            const userRes = await API.get("/user");
            const user = userRes.data;
            setUser(user)

// Determine is_takeout_menu based on table number
            const takeoutParam = user.table == 20 ? "1" : "0";

            const [menuData] = await Promise.all([
                API.get("/customer/sets", {
                    params: {
                        is_available: true,    // optional: only available items
                        is_takeout_menu: takeoutParam,// optional: only dine-in items
                    }
                }),
            ]);

            setMenu(menuData.data.menu)
        } catch (err) {
            console.error("Failed to fetch data", err);
        }
    };

    const openModal = (lavel, cat_id, catName, food_id) => {
        console.log(lavel, cat_id, food_id)
        const selectedFood = menu[lavel][cat_id].foods.find(foodItem => foodItem.id == food_id)
        setSelectedItem(selectedFood);
        setSelectedCat(catName);
        setSelectedSpice(spiceLevels[0]);
        setSelectedQty(1);
        setModalOpen(true);
    };

    const handleOpenCheckout = () => setShowCheckout(true);

    const handleQuantityChange = async (cartId, quantity) => {
        if (quantity < 1) return;
        try {
            await API.put(`/cart/${cartId}`, { quantity });
            await fetchCart()
        } catch (err) {
            console.error("Failed to update quantity", err);
        }
    };

    const handleIncrement = (c) => handleQuantityChange(c.id, c.quantity + 1);
    const handleDecrement = (c) => handleQuantityChange(c.id, c.quantity - 1);

    const closeModal = () => {
        setModalOpen(false);
        setSelectedCat(null);
        setSelectedItem(null);
        setSelectedQty(null);
        setSelectedItem(null);
    };

    const handleConfirmOrder = async (tableNumber) => {
        try {
            await API.post("/order", { table_number: tableNumber });
            alert("Order placed successfully!");
            setCart([]);
            setShowCheckout(false);
        } catch (err) {
            console.error("Checkout failed", err);
        }
    };

    const addToOrder = async () => {
        const nameWithSpice = `${selectedItem.name} (${selectedSpice})`;
        let mappedCart;
        let hasEmptySlot = false;

        if (selectedCat === 'set') {
            hasEmptySlot = selectedItem.slots.some(
                slot => !Array.isArray(slot.selectedFoods) || slot.selectedFoods.length === 0
            );

            if (hasEmptySlot) {
                return;
            }
            const data = selectedItem.slots.map(slot => {
                if (slot.type === 'changeable' || slot.type === 'fixed') {
                    const selectedSlot = slot.selectedFoods[0]; // only 1 item
                    return {
                        chosen_food_id: selectedSlot.id,
                        slot_id: slot.id,
                        slot_type: slot.type,
                        spice_level: selectedSlot.spice_level ?? null
                    };
                }

                // For changeable slots, combine all selectedFoods into one object
                return {
                    chosen_food_ids: slot.selectedFoods.map(f => ({
                        food_id: f.id,
                        spice_level: f.spice_level,
                    })),
                    slot_id: slot.id,
                    slot_type: slot.type
                };

            });

            mappedCart = {
                'set_menu_id': selectedItem.id,
                'quantity': selectedQty,
                'type': 'set_menu',
                'slots': data
            }

        } else {
            mappedCart = {
                'food_id': selectedItem.id,
                'quantity': selectedQty,
                'spice_level': selectedSpice,
                'type': 'food'
            }
        }

        await API.post("/cart/add", mappedCart);
        await fetchCart();

        closeModal();
    };

    const handleRemoveFromCart = async (cartId) => {
        try {
            await API.delete(`/cart/${cartId}`);
            await fetchCart();
        } catch (err) {
            console.error("Failed to remove item", err);
        }
    };

    const removeItem = (name) => setOrders(orders.filter((o) => o.name !== name));

    const totalAmount = orders.reduce((sum, item) => sum + item.price * item.quantity, 0);

    const checkout = () => {
        if (orders.length === 0) return alert("Please add items to your order first!");
        const summary = orders.map((i) => `${i.name} x${i.quantity}: ¥${i.price * i.quantity}`).join("\n");
        alert(`Order confirmed!\n\n${summary}\n\nTotal: ¥${totalAmount}`);
        setOrders([]);
    };

    const categories = [
        { title: "LUNCH", keys: ["Lunch Item 1"] },
        { title: "DINNER", keys: ["Dinner Item 1"] },
        { title: "A LA CARTE", keys: ["Appetizer 1"] }
    ];

    useEffect(() => {
        fetchMenuData();
        fetchCart()
    }, []);

    return (
        <div className={styles.container}>
            <div className={styles["menu-section"]}>
                <div className={styles["page-title"]}>Menu Page</div>

                {menu && Object.keys(menu).length > 0 &&
                    Object.keys(menu).map((lavel) => (
                        <div key={lavel} className={styles.category}>
                            <div className={styles["category-title"]}>
                                <p style={{margin: 0, fontSize: "1.4rem", fontWeight: "700"}}>
                                    {ln === "en" ? getMenuRow(lavel).label || '' : getMenuRow(lavel).jp || ""}
                                </p>
                                <p style={{margin: 0, fontSize: "1.2rem", opacity: 0.8}}>
                                    <span>{getMenuRow(lavel).time}</span>
                                </p>
                            </div>
                            <div className={styles["category-title"]}>
                                {Object.entries(menu[lavel]).map(([catId, categoryData]) => (
                                    <div key={catId}>
                                        <h3>
                                       <span>
                                          {ln === "en"
                                              ? categoryData.category["name"] ||
                                              categoryData.category["japanese_name"] ||
                                              ""
                                              : categoryData.category["japanese_name"] ||
                                              categoryData.category["name"] ||
                                              ""}
                                        </span>
                                        </h3>
                                        <div className={styles["menu-grid"]}>
                                            {categoryData.foods.map((food) => (
                                                <div key={food.id} className={styles["menu-card"]}>
                                                    <img
                                                        className={styles["menu-card-image"]}
                                                        src={imageSrc(food.images ? food.images[0] : "https://via.placeholder.com/150")}
                                                        alt={food.name || food.title}
                                                    />
                                                    <div className={styles["menu-card-name"]}>
                                                      <span>
                                                      {ln === "en" ? food.name || food.title || "" : food.japanese_name || food.japanese_title || ""}
                                                    </span>

                                                    </div>

                                                    <button
                                                        className={styles["menu-card-btn"]}
                                                        onClick={() =>
                                                            openModal(
                                                                lavel,
                                                                catId,
                                                                categoryData.category["name"],
                                                                food.id
                                                            )
                                                        }
                                                    >
                                                        {ln === "en" ? "Select" : "選択"}
                                                    </button>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
            </div>

            {/* ORDER SECTION */}
            <div className={styles["order-section"]}>
                <div className="form-check form-switch">
                    <input
                        className="form-check-input"
                        type="checkbox"
                        id="langSwitch"
                        checked={ln === "jp"}
                        onChange={() => setLn(ln === "en" ? "jp" : "en")}
                    />
                    <label className="form-check-label" htmlFor="langSwitch">
                        {ln.toUpperCase()}
                    </label>
                </div>

                {/* Header */}
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        backgroundColor: "#ffffff",
                        padding: "1rem",
                        borderRadius: "12px",
                        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                        marginBottom: "1rem",
                    }}
                >
                    {/* Left side: Table No and Add to Cart */}
                    <div>
                        <h4 style={{fontSize: "1.5rem", fontWeight: "600", color: "#333", margin: 0}}>
                            {user?.table == 20 ? "TakeOut" : `Table No: ${user?.table || ""}`}
                        </h4>
                        <h5 style={{fontSize: "1.1rem", fontWeight: "500", color: "#555", margin: 0}}>
                            Add to Cart
                        </h5>
                    </div>


                    {/* Right side: My Orders button, only if at least one order exists */}
                    {(
                        <Button
                            variant="outline-primary"
                            onClick={() => setShowOrdersModal(true)}
                        >
                            My Orders
                        </Button>
                    )}
                </div>
                <div className={styles["order-items"]}>
                    {cart.length === 0 && (
                        <div style={{textAlign: "center", color: "#999", padding: 20}}>
                            No items yet
                        </div>
                    )}

                    <div className="flex-grow-1 overflow-auto">
                        <ListGroup>
                            {cart.map((c) => (
                                <ListGroup.Item
                                    key={c.id}
                                    className="d-flex justify-content-between align-items-center"
                                >
                                    <div style={{flex: 1}}>
                                        <strong>{c.title}</strong>
                                        <div className="text-muted">{c.jp}</div>
                                        <div className="text-warning small">¥{c.price.toFixed(0)} / item</div>

                                        {c.type === "set_menu" && c.items?.length > 0 && (
                                            <ListGroup className="mb-1 mt-1">
                                                {c.items.map((i, idx) => (
                                                    <ListGroup.Item key={idx} className="py-1 px-2 small">
                                                        {i.name} ({i.japanese_name || i.jp})
                                                    </ListGroup.Item>
                                                ))}
                                            </ListGroup>
                                        )}

                                        <div className="d-flex align-items-center mt-1">
                                            <Button
                                                variant="outline-secondary"
                                                size="sm"
                                                onClick={() => handleDecrement(c)}
                                            >
                                                <Minus size={16}/>
                                            </Button>
                                            <InputGroup size="sm" className="mx-1" style={{width: "50px"}}>
                                                <FormControl
                                                    value={c.quantity}
                                                    // onChange={(e) =>
                                                    //     handleQuantityChange(c.id, parseInt(e.target.value))
                                                    // }
                                                />
                                            </InputGroup>
                                            <Button
                                                variant="outline-secondary"
                                                size="sm"
                                                onClick={() => handleIncrement(c)}
                                            >
                                                <Plus size={16}/>
                                            </Button>
                                        </div>
                                    </div>

                                    <Button
                                        variant="danger"
                                        size="sm"
                                        onClick={() => handleRemoveFromCart(c.id)}
                                    >
                                        <Trash2 size={16}/>
                                    </Button>
                                </ListGroup.Item>
                            ))}
                        </ListGroup>
                    </div>
                </div>

                <div className="mt-3 text-center">
                    <h5 style={{fontSize: "2rem", fontWeight: "700"}}>
                        Total: ¥
                        {cart.reduce((sum, item) => sum + item.total_price, 0).toFixed(0)}
                    </h5>

                    <Button
                        className="w-100 mb-2"
                        onClick={handleOpenCheckout}
                        disabled={cart.length === 0}
                        style={{
                            height: "100px",           // taller button
                            fontSize: "2.6rem",       // larger text inside button
                            fontWeight: "700",        // make it bold
                        }}
                    >
                        Checkout
                    </Button>
                </div>

            </div>

            {/* MODAL */}
            {modalOpen && selectedItem && (
                <div
                    className={`${styles.modal} ${styles.active}`}
                    onClick={(e) => e.target.classList.contains(styles.modal) && closeModal()}
                >
                    <div className={styles["modal-content"]}>
                        <img
                            src={
                                selectedItem.images
                                    ? imageSrc(selectedItem.images[0])
                                    : "https://via.placeholder.com/150"
                            }
                            alt={selectedItem.name || selectedItem.title}
                            className={styles["modal-item-image"]}
                        />

                        <div className={styles["modal-item-price"]}>
                            <Card.Title style={{
                                fontWeight: 700,
                                fontSize: "3.6rem"
                            }}>¥{parseFloat(selectedItem.price || selectedItem.base_price || 0).toFixed(0)}</Card.Title>
                        </div>

                        <div className={styles["modal-item-name"]} style={{fontWeight: 800, fontSize: "1.5rem"}}>
                            {ln === "en" ? (selectedItem.name || selectedItem.title || '') : (selectedItem.japanese_name || selectedItem.jp_title)}
                        </div>

                        {selectedItem.description && (
                            <div className={styles["modal-item-description"]}
                                 style={{fontWeight: 700, fontSize: "1rem"}}>
                                {ln === "en" ? (selectedItem.description || '') : (selectedItem.jp_description || '')}
                            </div>
                        )}

                        {selectedItem.spice_level && (
                            <div className={styles["spice-level-group"]}>
                                <label className={styles["spice-level-label"]}>Spice Level:</label>

                                <select
                                    className={styles["spice-level-select"]}
                                    value={selectedSpice}
                                    onChange={(e) => setSelectedSpice(e.target.value)}
                                >
                                    {SPICE_LEVELS.map((level) => (
                                        <option key={level.index} value={level.value}>
                                            {ln === 'en'? level.en_title: level.title} {level.icon}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        )}

                        {selectedItem.slots && (
                            <div className={styles["slot-container"]}>
                                {selectedItem.slots.map((slot) => {
                                    // Determine default selected food for fixed/choosable slot
                                    const defaultSelected = (slot.type === "fixed" || slot.type === "changeable")
                                        ? [slot.foods[0]]
                                        : slot.selectedFoods || [];

                                    // If slot.selectedFoods is empty for fixed/changeable, set it to defaultSelected
                                    if ((slot.type === "fixed" || slot.type === "changeable") && (!slot.selectedFoods || slot.selectedFoods.length === 0)) {
                                        slot.selectedFoods = defaultSelected;
                                    }

                                    return (
                                        <div key={slot.id} className={styles["slot-column"]}>
                                            <div
                                                className={styles["slot-category"]}
                                                style={{
                                                    fontWeight: 700,
                                                    fontSize: slot.type === "fixed" ? "1.3rem" : "2rem",
                                                    paddingTop: slot.type === "fixed" ? "1.3rem" : "inherit"
                                                }}
                                            >
                                                {ln === 'en' ? slot.category?.name : slot.category?.japanese_name}
                                            </div>
                                            <div className={styles["slot-action"]}>
                                                {slot.type !== "fixed" && (
                                                    <Button
                                                        className={styles["slot-btn"]}
                                                        size="lg"
                                                        style={{
                                                            padding: "20px 40px",
                                                            fontSize: "1.2rem" // or "large" depending on your framework
                                                        }}
                                                        variant={slot.type === "changeable" ? "warning" : "info"}
                                                        onClick={() => {
                                                            setActiveSlot(slot);
                                                            setSelectedSlotFoods(slot.selectedFoods || defaultSelected);
                                                            setShowSlotModal(true);
                                                        }}
                                                    >
                                                        {slot.type === "changeable" ? (ln === 'en'? "change" : "変化"): (ln === 'en'? "choose" : "選ぶ")}
                                                    </Button>
                                                )}
                                            </div>

                                            {/* Show selected foods below button */}
                                            <div className={styles["slot-selected-foods"]}>
                                                {(slot.selectedFoods || defaultSelected).map((food) => (
                                                    <p key={food.id} className={styles["slot-food-name"]}
                                                       style={{fontWeight: "bold"}}>
                                                        {ln === "jp" ? food.japanese_name : food.name}
                                                        {food.spice_level && (<span>({getSpiceTitle(food.spice_level)})</span>)}
                                                    </p>
                                                ))}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        )}

                        <div className={styles["quantity-group"]}>
                            <label className={styles["quantity-label"]}>Quantity:</label>

                            <div className={styles["quantity-controls"]}>
                                <button
                                    className={styles["quantity-btn"]}
                                    onClick={() => setSelectedQty((q) => Math.max(1, q - 1))}
                                >
                                    −
                                </button>

                                <input
                                    type="number"
                                    className={styles["quantity-input"]}
                                    value={selectedQty}
                                    onChange={(e) =>
                                        setSelectedQty(Math.max(1, Number(e.target.value)))
                                    }
                                />

                                <button
                                    className={styles["quantity-btn"]}
                                    onClick={() => setSelectedQty((q) => q + 1)}
                                >
                                    +
                                </button>
                            </div>
                        </div>

                        <div className={styles["modal-actions"]}>
                            <button
                                className={`${styles["modal-btn"]} ${styles["modal-btn-remove"]}`}
                                onClick={closeModal}
                            >
                                ✕
                            </button>

                            <button
                                style={{ padding: "15px", fontSize: "25px", fontWeight: 500 }}
                                className={`${styles["modal-btn"]} ${styles["modal-btn-select"]}`}
                                onClick={addToOrder}
                            >
                                {ln === 'en'? 'Add to Cart' : 'カートに追加'}
                            </button>
                        </div>
                    </div>
                </div>
            )}
            {showSlotModal && activeSlot && (
                <SlotSelectionModal
                    show={showSlotModal}
                    onHide={() => setShowSlotModal(false)}
                    slot={activeSlot}
                    selectedSlotFoods={selectedSlotFoods}
                    ln={ln}
                    setSelectedSlotFoods={(foods) => {
                        setSelectedSlotFoods(foods);
                        // Save selection back to the slot
                        const updatedSlots = selectedItem.slots.map((s) =>
                            s.id === activeSlot.id ? {...s, selectedFoods: foods} : s
                        );
                        setSelectedItem({...selectedItem, slots: updatedSlots});
                    }}
                />
            )}

            <CheckoutModal
                show={showCheckout}
                onClose={() => setShowCheckout(false)}
                cart={cart}
                handleConfirmOrder={handleConfirmOrder}
            />


            {/* --- My Orders Modal --- */}
            <Modal
                show={showOrdersModal}
                onHide={() => setShowOrdersModal(false)}
                size="lg"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>My Orders</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {loadingOrders && (
                        <div className="text-center">
                            <Spinner animation="border"/> Loading orders...
                        </div>
                    )}

                    {ordersError && <Alert variant="danger">{ordersError}</Alert>}

                    {!loadingOrders && !ordersError && orders.length === 0 && (
                        <Alert variant="info">No orders found.</Alert>
                    )}

                    {!loadingOrders &&
                        orders.length > 0 &&
                        orders.map((order) => (
                            <div key={order.id} className="mb-3 p-2 border rounded">
                                <div className="d-flex justify-content-between mb-2">
                                    <strong>Order #{order.id}</strong>
                                    <span>Status: {order.status}</span>
                                </div>

                                <Table striped bordered hover size="sm">
                                    <thead>
                                    <tr>
                                        <th>Item</th>
                                        <th>Sub-items</th>
                                        {/* Column for set menu sub-items */}
                                        <th>Unit Price</th>
                                        <th>Qty</th>
                                        <th>Additional Price</th>
                                        <th>Price</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {order.items.map((item, idx) => {

                                        return (
                                            <tr key={idx}>
                                                <td>{item.title} {item.spice_level && (
                                                    <span style={{color: "#ff4500", fontSize: "0.9rem"}}>
                      {/*{renderSpiceChili(item.spice_level)} ({getSpiceLabel(item.spice_level)})*/}
                    </span>
                                                )}</td>
                                                <td>
                                                    {item.meta?.slots?.length > 0 ? (
                                                        <ul className="mb-0 p-0" style={{listStyle: "none"}}>
                                                            {item.meta.slots.map((s, i) => (
                                                                <li key={i}>
                                                                    {s.food_name} {s.spice_level && (
                                                                    <span
                                                                        style={{color: "#ff4500", fontSize: "0.9rem"}}>
                      {/*{renderSpiceChili(s.spice_level)} ({getSpiceLabel(s.spice_level)})*/}
                    </span>
                                                                )} {s.additional_price > 0 && `( +¥${s.additional_price})`}
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    ) : (
                                                        "-"
                                                    )}
                                                </td>
                                                <td>¥{(item.price * 1).toFixed(0)}</td>
                                                <td>{item.quantity}</td>
                                                <td>{item.additional_price}</td>
                                                <td>¥{(item.total_price).toFixed(0)}</td>
                                            </tr>
                                        );
                                    })}
                                    </tbody>
                                </Table>

                                {/* Dynamic total calculated from items */}
                                <div className="text-end">
                                    <strong>
                                        Total: ¥
                                        {order.items
                                            .reduce((sum, item) => item.total_price, 0)
                                            .toFixed(0)}
                                    </strong>
                                </div>
                            </div>
                        ))}

                    {orders.length > 0 && (
                        <div className="mt-3 text-end">
                            <h5>
                                🧾 Cumulative Total: ¥
                                {orders
                                    .reduce(
                                        (sum, order) =>
                                            sum + order.items.reduce((s, item) => s + item.price * item.quantity, 0),
                                        0
                                    )
                                    .toFixed(0)}
                            </h5>
                        </div>
                    )}
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default CustomerPanel;
